import type { SVGProps } from "react";

export default function TableIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 21, height = 21, ...rest } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.71436 0.500001H19.494C20.0496 0.500001 20.5 1.01477 20.5 1.64975V5.5H0.5V1.64975C0.5 1.01477 0.950462 0.500001 1.50604 0.500001H3.50712"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.500015 10.5H20.5"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 15.5H0.500015"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6282 20.5H19.0351C19.8442 20.5 20.5 19.7505 20.5 18.8259V5.50005H0.500015V18.8259C0.500015 19.7505 1.15587 20.5 1.96484 20.5H10.421"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.16656 5.6944V20.3595"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8333 5.6944V20.3595"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
